import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import type { Slug, UrlFriendlySlug } from '@bridebook/toolbox/src/types';
import { addCountryToSearchUrl } from '../add-country-to-search-url';
import { mapSlugToFriendlyUrlSlug } from '../mapSlugToFriendlyUrlSlug';
import { GEO_NAMES } from '../search-suppliers/location-helpers';
import slugify from '../slugify';

const removeThe = (urlArea: string) => urlArea.toLowerCase().replace(/^the-/g, '');

const locationRedirects: Record<string, string> = {
  armagh: 'county-armagh',
  craigavon: 'county-armagh',
  antrim: 'county-antrim',
  ballymena: 'county-antrim',
  ballymoney: 'county-antrim',
  carrickfergus: 'county-antrim',
  larne: 'county-antrim',
  moyle: 'county-antrim',
  newtownabbey: 'county-antrim',
  lisburn: 'county-antrim',
  derry: 'county-londonderry',
  limavady: 'county-londonderry',
  magherafelt: 'county-londonderry',
  coleraine: 'county-londonderry',
  ards: 'county-down',
  down: 'county-down',
  banbridge: 'county-down',
  'newry-and-mourne': 'county-down',
  'north-down': 'county-down',
  castlereagh: 'county-down',
  fermanagh: 'county-fermanagh',
  strabane: 'county-tyrone',
  cookstown: 'county-tyrone',
  'dungannon-and-south-tyrone': 'county-tyrone',
  omagh: 'county-tyrone',
};

export const getSearchArea = ({ area, areaContext }: { area?: string; areaContext?: string[] }) => {
  const areaWithContext =
    area && areaContext && areaContext.length > 0
      ? `${area}--${areaContext.join('--')}`
      : area || GEO_NAMES.UK;

  const sluggedArea = removeThe(slugify(areaWithContext));
  return locationRedirects[sluggedArea] || sluggedArea;
};

export const getSearchUrlWithCountrySuffix = ({
  slug,
  area,
  areaContext,
  as = true,
  countryCode,
}: {
  slug: Slug | UrlFriendlySlug;
  area?: string;
  areaContext?: string[];
  as?: boolean;
  countryCode: CountryCodes;
}): string => addCountryToSearchUrl(getSearchUrl({ slug, area, areaContext, as }), countryCode);

const getSearchUrl = ({
  slug,
  area,
  areaContext,
  as = false,
  fallbackToDefaultArea = true,
}: {
  slug: Slug | UrlFriendlySlug;
  area?: string;
  areaContext?: string[];
  as?: boolean;
  fallbackToDefaultArea?: boolean;
}): string => {
  const category = mapSlugToFriendlyUrlSlug(slug).newSlug;
  const slugArea = getSearchArea({ area, areaContext });

  const includeArea = fallbackToDefaultArea || !!area;

  return as
    ? `/search/wedding-${category}${includeArea ? '/' + slugArea : ''}`
    : `/search?${includeArea ? `area=${slugArea}&` : ''}slug=${category}`;
};

export default getSearchUrl;
